import { z } from 'zod';
import { audiencePreviewSchema, communicationMessageSchema, sendMessageCommandSchema, } from './communication.js';
import { notificationChangeFeedSchema, notificationIntentReceiptSchema, notificationIntentSchema, } from './notifications.js';
const asJsonSchema = (schema) => z.toJSONSchema(schema, { target: 'draft-2020-12' });
const idempotencyHeader = {
    name: 'Idempotency-Key',
    in: 'header',
    required: true,
    schema: { type: 'string', minLength: 16, maxLength: 200 },
};
export const notificationsOpenApiDocument = {
    openapi: '3.1.0',
    info: {
        title: 'SAD5 Powiadomienia API',
        version: '1.0.0',
        description: 'Wersjonowane intencje, centrum powiadomień i statusy kanałów.',
    },
    servers: [{ url: '/api/notifications/v1' }],
    paths: {
        '/intents': {
            post: {
                operationId: 'acceptNotificationIntentV1',
                parameters: [idempotencyHeader],
                requestBody: {
                    required: true,
                    content: {
                        'application/json': {
                            schema: { $ref: '#/components/schemas/NotificationIntent' },
                        },
                    },
                },
                responses: {
                    '202': {
                        description: 'Intencja przyjęta.',
                        content: {
                            'application/json': {
                                schema: {
                                    $ref: '#/components/schemas/NotificationIntentReceipt',
                                },
                            },
                        },
                    },
                },
            },
        },
        '/me/changes': {
            get: {
                operationId: 'getNotificationChangesV1',
                parameters: [
                    {
                        name: 'cursor',
                        in: 'query',
                        required: false,
                        schema: { type: 'string' },
                    },
                ],
                responses: {
                    '200': {
                        description: 'Kanoniczny change feed po utracie WebSocket.',
                        content: {
                            'application/json': {
                                schema: { $ref: '#/components/schemas/NotificationChangeFeed' },
                            },
                        },
                    },
                },
            },
        },
    },
    components: {
        schemas: {
            NotificationIntent: asJsonSchema(notificationIntentSchema),
            NotificationIntentReceipt: asJsonSchema(notificationIntentReceiptSchema),
            NotificationChangeFeed: asJsonSchema(notificationChangeFeedSchema),
        },
    },
};
export const communicationOpenApiDocument = {
    openapi: '3.1.0',
    info: {
        title: 'SAD5 Komunikacja API',
        version: '1.0.0',
        description: 'Wersjonowane rozmowy, skrzynki i kolejki zespołowe.',
    },
    servers: [{ url: '/api/communication/v1' }],
    paths: {
        '/audiences/preview': {
            post: {
                operationId: 'previewCommunicationAudienceV1',
                requestBody: {
                    required: true,
                    content: {
                        'application/json': {
                            schema: {
                                type: 'object',
                                required: ['audience'],
                                properties: { audience: { type: 'array' } },
                            },
                        },
                    },
                },
                responses: {
                    '200': {
                        description: 'Podgląd bez listy odbiorców.',
                        content: {
                            'application/json': {
                                schema: { $ref: '#/components/schemas/AudiencePreview' },
                            },
                        },
                    },
                },
            },
        },
        '/messages': {
            post: {
                operationId: 'sendCommunicationMessageV1',
                parameters: [idempotencyHeader],
                requestBody: {
                    required: true,
                    content: {
                        'application/json': {
                            schema: { $ref: '#/components/schemas/SendMessageCommand' },
                        },
                    },
                },
                responses: {
                    '201': {
                        description: 'Wiadomość zapisana z raportem per odbiorca.',
                        content: {
                            'application/json': {
                                schema: { $ref: '#/components/schemas/CommunicationMessage' },
                            },
                        },
                    },
                },
            },
        },
    },
    components: {
        schemas: {
            SendMessageCommand: asJsonSchema(sendMessageCommandSchema),
            AudiencePreview: asJsonSchema(audiencePreviewSchema),
            CommunicationMessage: asJsonSchema(communicationMessageSchema),
        },
    },
};
